import { httpServiceClient } from '@/infra/http'
import { NamingStrategy } from '@/infra/http/http-service-client/http-service-client-types'
import { makeApiUrl } from '@/main/factories/http/api-url-factory'
import { ProductFitScoreResponse } from './product-fit-score-service-types'
import { formatProductFitScore } from './product-fit-score-service-utils'

const getProductFitScoreUrl = (productId: number) =>
  makeApiUrl(`/catalog/v2/products/${productId}/fit-score`)

export const createProductFitScoreService = (client = httpServiceClient) => ({
  /**
   * `offerId` é opcional. Sem ele o backend avalia todas as ofertas do produto e devolve a
   * de maior compatibilidade, identificando-a em `selectedOffer` — é a chamada que o data
   * loader faz ao abrir a PDV. Com ele, o cálculo é só daquela oferta, que é o que a PDV de
   * idiomas refaz quando o usuário troca a seleção no wizard.
   */
  async fetchProductFitScore(productId: number, offerId?: number | null) {
    const response = await client<ProductFitScoreResponse>({
      method: 'get',
      url: getProductFitScoreUrl(productId),
      params: { offerId: offerId ?? undefined },
      paramsNamingStrategy: NamingStrategy.snakeCase
    })

    return formatProductFitScore(response.body.data as ProductFitScoreResponse)
  }
})

export const productFitScoreService = createProductFitScoreService()
